export enum ProfileReduxActions {
    SET_PROFILE_DATA = 'SET_PROFILE_DATA',
    UPDATE_MOBILE_NUMBER = 'UPDATE_MOBILE_NUMBER',
    UPDATE_2FA_STATUS = 'UPDATE_2FA_STATUS',
    UPDATE_TEMPLATE_ID = 'UPDATE_TEMPLATE_ID',
    UPDATE_GLOBALLY_TEMPLATE_ID = 'UPDATE_GLOBALLY_TEMPLATE_ID',
    UPDATE_GLOBALLY_TEMPLATE_STATUS = 'UPDATE_GLOBALLY_TEMPLATE_STATUS',
    UPDATE_CUSTOM_TEMPLATE_STATUS = 'UPDATE_CUSTOM_TEMPLATE_STATUS',
}

const setTemplateId = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_TEMPLATE_ID,
    payload,
});
const setGloballyTemplateStatus = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_GLOBALLY_TEMPLATE_STATUS,
    payload,
});
const setCustomTemplateStatus = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_CUSTOM_TEMPLATE_STATUS,
    payload,
});
const setGloballyTemplateId = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_GLOBALLY_TEMPLATE_ID,
    payload,
});
const setProfileData = (payload: any): any => ({
    type: ProfileReduxActions.SET_PROFILE_DATA,
    payload,
});

const updateMobileNumber = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_MOBILE_NUMBER,
    payload,
});

const update2FAStatus = (payload: any): any => ({
    type: ProfileReduxActions.UPDATE_2FA_STATUS,
    payload,
});

export const ProfileActions = {
    setTemplateId,
    setGloballyTemplateId,
    setGloballyTemplateStatus,
    setCustomTemplateStatus,
    setProfileData,
    updateMobileNumber,
    update2FAStatus,
};
